import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import InventoryItem from './InventoryItem';

const InventoryEditTopCategoryAccodion = (props) => {

  const [isOpen, setIsOpen] = useState(props.isOpen);

  let isEvenRow = false;

  const getRowClass = () => {
    isEvenRow = !isEvenRow;
    return `product-list-view--${isEvenRow ? 'even' : 'odd'}`;
  }

  return (
    <>
      <div className='inventoryEdit__accordion' onClick={() => setIsOpen(prevState => !prevState)}>
        <h2 className='category'>{props.topInventoryCategory.name}</h2>
        <div className={`inventoryEdit__accordion-caret ${isOpen ? 'active' : ''}`} aria-label='Open accordion'></div>
      </div>
      { isOpen && (
        <div aria-expanded="true">
          {props.topInventoryCategory.subInventoryCategories.map((subInventoryCategory) => {
            return (
              <>
                <h2 className='serie'>{subInventoryCategory.name}</h2>
                <div className="tablediv">
                  <table className="product-listview-table defaulttable">
                    <thead className="product-list-view-head">
                      <tr>
                        <th className='image'>{translate('product.productphoto')}</th>
                        <th className='name'>{translate('product.productmodel')}</th>
                        <th className="min-witdh--small">{translate('product.articlenumber')}</th>
                        <th className="min-witdh--small">{translate('product.quantity')}</th>
                        <th className="min-witdh--small">{translate('product.confirm')}</th>
                        <th className="min-witdh--small">{translate('product.remove')}</th>
                      </tr>
                    </thead>
                    <tbody>
                    {subInventoryCategory.inventoryEditItems.map((product) => {
                      return (
                        <InventoryItem key={product.systemId} product={product} trClassName={getRowClass()} setProducts={props.setProducts}/>
                      )
                    })}
                    </tbody>
                  </table>
                </div>
              </>
            )
          })}
        </div>
      )}
    </>
  )
}

export default InventoryEditTopCategoryAccodion;